export default "__VITE_ASSET__356be853__"